var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2348 19.6404C10.4802 19.6404 6.41992 20.3592 6.41992 23.2382C6.41992 26.1172 10.4544 26.8618 15.2348 26.8618C19.9893 26.8618 24.0484 26.1418 24.0484 23.264C24.0484 20.3862 20.0151 19.6404 15.2348 19.6404Z",
    stroke: "#828282",
    strokeWidth: 1.84399,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2347 15.534C18.3549 15.534 20.8838 13.0039 20.8838 9.88378C20.8838 6.76364 18.3549 4.23474 15.2347 4.23474C12.1146 4.23474 9.58451 6.76364 9.58451 9.88378C9.57397 12.9934 12.0865 15.5235 15.1949 15.534H15.2347Z",
    stroke: "#828282",
    strokeWidth: 1.75618,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.0ed057bbd6ce666a675bf08c93c65af0.svg";
export { ForwardRef as ReactComponent };